import React from "react";
import PayrollRomms from "../../payroll/PayrollRomms";

interface OtherReceivablesRommsProps {
  onBack?: () => void;
}

export default function OtherReceivablesRomms({ onBack }: OtherReceivablesRommsProps) {
  return <PayrollRomms onBack={onBack || (() => {})} onComplete={() => {}} workspace="Other Receivables" />;
}
